import { onSubmit } from '../../handlers';

export  const handleChange = (stateProps, formikProps,newValue,index ) => {

  formikProps.values.jobSeekerData[index] ={'template_id': newValue};
  onSubmit(formikProps, stateProps);
};
export const getImg = (imgDomain,label) => {
  let imgString = imgDomain+ '/resume_template_' + label.toLowerCase() + '.png';
  imgString = imgString.replace(' ', '_');
  return imgString;
}
export const getFocus = (props,template,thisTemplate) => {
  const focusLabel = props.stateProps.focus[template.label];
  let focus = 2;
  if (typeof focusLabel !== 'undefined'  ) {
    focus = focusLabel;
  }

  const selectedTemplate = props.formikProps.values.jobSeekerData[0]['template_id'];
  if (typeof selectedTemplate !== 'undefined' && selectedTemplate === thisTemplate ) {
      focus =0;

  }


  return focus;
}
export const handleFocus = (stateProps,template) => {
  const focus = { };
  focus[template.label] = 0;
  stateProps.setFocus(focus);
  const counter = stateProps.counter;
  stateProps.setCounter(counter+1);
};
export const handleUnfocus = (stateProps,template) => {
  const focus = stateProps.focus;
  focus[template.label] =2;
  stateProps.setFocus(focus);
  const counter = stateProps.counter;
  stateProps.setCounter(counter+1);
};